// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__3UC3M","icon":"Button_icon__3A5TS","setting_block":"Button_setting_block__2pdYw","name":"Button_name__GR9h5","fadeIn":"Button_fadeIn__2KBXU"};